/**
 * Component departures-pricelist JS
 *
 * !!! Uncomment only if component is needed, this way the compiler will ignore useless files
 */

jQuery(document).ready(function () {
    const component = jQuery('.departures-pricelist');

    if (!component.length) {
        return;
    }

    /**
     * Mobile Departure Selection
     */
    jQuery('.departures-pricelist .departures-pricelist__mobile-item-link').bind('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        jQuery('.departures-pricelist .departures-pricelist__mobile-item-link').removeClass('is-active');
        jQuery(this).addClass('is-active');

        jQuery('.destination-item-default').removeClass('is-active');
        jQuery('.destination-item-default.' + jQuery(this).data('selection')).addClass('is-active');
    });

    /**
     * Desktop Departure Selection
     */
    jQuery('.departures-pricelist .departures-pricelist__desktop-item-link').bind('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        jQuery('.departures-pricelist .departures-pricelist__desktop-item-link').removeClass('active');
        jQuery(this).addClass('active');

        jQuery('.destination-item-default').removeClass('is-active');
        jQuery('.destination-item-default.' + jQuery(this).data('selection')).addClass('is-active');
    });

    /**
     * CTA Form Filler
     */
    jQuery('.departures-pricelist .ll-destination-cta').bind('click', function (e) {
        //e.preventDefault();
        e.stopPropagation();

        const pickup = jQuery(this).data('pickup');
        const dropoff = jQuery(this).data('dropoff');
        //console.log(pickup);
        //console.log(dropoff);

        jQuery('#data-pickup').val(pickup);
        jQuery('#data-dropoff').val(dropoff);
    });

    /**
     * Mobile Slider
     */
    jQuery('.departures-pricelist .departures-pricelist__mobile-items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        variableWidth: false,
        adaptiveHeight: true,
    }).on('afterChange', function (event, slick, currentSlide) {
        const $currentSlide = jQuery(slick.$slides.get(currentSlide));
        const selectionClass = $currentSlide.find('.departures-pricelist__mobile-item-link').data('selection');

        // Aggiorna attivi
        jQuery('.departures-pricelist__mobile-item-link').removeClass('is-active');
        $currentSlide.find('.departures-pricelist__mobile-item-link').addClass('is-active');

        jQuery('.destination-item-default').removeClass('is-active');
        jQuery('.destination-item-default.' + selectionClass).addClass('is-active');
    });

});